import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import ScorecardCreationContainer from './ScorecardCreationContainer';
import ScorecardPreviewTitleBar from './ScorecardPreviewTitleBar';
import ScorecardTemplate from '../Monitoring/Scorecards/ScorecardTemplate';
import { APIContext } from 'src/components/Contexts/APIContext'
import ScorecardProvider from '../Contexts/ScorecardContext';

const styles = {
    fullHeight: {
        height: '100%'
    },
    bgColour: {
        backgroundColor: 'rgb(245, 245, 245)'
    }
}

type Props = {
    id: number;
    close: () => void;
}

export default function ScorecardPreviewContainer({ id, close }: Props) {
    const { get } = useContext(APIContext);
    const [completeId, setCompleteId] = useState<number | null>(null);

    useEffect(() => {
        get('ScorecardManagement', `AddScorecardComplete?templateId=${id}`, (data) => setCompleteId(data))
    }, [])

    return (
        <Fragment>
            <Box display="flex" sx={{ ...styles.fullHeight, ...styles.bgColour }} flexDirection="column"  >
                <Box flexGrow={1} overflow="auto">
                    <Grid container sx={styles.fullHeight}>
                        <Grid size={5} sx={styles.fullHeight}>
                            <Box display="flex" flexDirection="column" sx={styles.fullHeight}>
                                <ScorecardPreviewTitleBar id={id} close={close} />
                                <Box flexGrow={1} overflow="auto" paddingRight={1}>
                                    <ScorecardCreationContainer id={id} />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={7} sx={{ height: '100%', overflow: 'hidden' }}>
                            {
                                completeId &&
                                <ScorecardProvider>
                                    <ScorecardTemplate
                                        callRefId="Test Scorecard"
                                        scorecardId={completeId}
                                        scorecardBuilderView={true} />
                                </ScorecardProvider>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Fragment>
    );
}